import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { Inline } from '@atlaskit/primitives';
import { default as Button, LinkButton } from '@atlaskit/button/new';

import { Modal } from '@atlassian/growth-pattern-library-modal';

import { FeatureComparisonPanel } from './feature-comparison-panel';

type CloseProps = {
	onClose: (reason: string) => void;
	message: string;
};

type CtaProps = {
	url: string;
	onClick: () => void;
};

type ImprovedAuaContentModalProps = {
	close: CloseProps;
	height: number;
	width: number;
	header: React.ReactNode;
	children: React.ReactNode;
	cta: CtaProps;
};

export const ImprovedAuaContentModal = ({
	close,
	header,
	height,
	children: leftContent,
	width,
	cta,
}: ImprovedAuaContentModalProps) => {
	const { formatMessage } = useIntl();

	return (
		<Modal
			testId="improved-aua-content-modal"
			onClose={() => close.onClose('cancel')}
			title={header}
			subtitle={formatMessage(messages.modalSubheading)}
			height={height}
			width={width}
			sideContent={<FeatureComparisonPanel />}
			shouldScrollInViewport={false}
			shouldCloseOnEscapePress
			shouldCloseOnOverlayClick
			actions={
				<Inline alignInline="end" space="space.150">
					<Button
						appearance="subtle"
						testId="improved-aua-modal-conversion-cancel-button"
						onClick={() => close.onClose('cancel')}
					>
						{close.message}
					</Button>
					<LinkButton
						testId="improved-aua-modal-conversion-primary-button"
						appearance="primary"
						href={cta.url}
						onClick={() => cta.onClick()}
						target="_blank"
					>
						{formatMessage(messages.modalPrimaryCta)}
					</LinkButton>
				</Inline>
			}
		>
			{leftContent}
		</Modal>
	);
};

export const messages = defineMessages({
	modalSubheading: {
		id: 'experiment-aua-improve-conversion.subheading',
		defaultMessage: `Start a free, 14-day Standard trial. Cancel anytime, we‘ll remind you 3 days before your trial ends.`,
		description: 'The subheading of the improved AUA modal conversion experiment.',
	},
	modalPrimaryCta: {
		id: 'experiment-aua-improve-conversion.primary-cta',
		defaultMessage: 'Try it now',
		description:
			'The primary CTA of the improved AUA modal conversion experiment that initiates a trial.',
	},
});
